const Me = () => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="#E0E0E0" />
      <g clipPath="url(#clip0_30_9)">
        <path
          d="M8.42639 8.0625C8.42639 6.09295 10.022 4.5 11.9948 4.5C13.9676 4.5 15.5632 6.09295 15.5632 8.0625C15.5632 10.0321 13.9676 11.625 11.9948 11.625C10.022 11.625 8.42639 10.0321 8.42639 8.0625ZM17.9591 16.9026C17.8826 16.5921 17.7807 16.2919 17.6583 16.0018C16.7509 13.9304 14.5793 12.6429 11.9948 12.6429C9.0585 12.6429 6.66768 14.3325 6.04576 16.8517C5.84185 17.6711 6.33633 18.5006 7.15706 18.7042C7.27941 18.7347 7.40175 18.75 7.52919 18.75H16.4604C16.9345 18.75 17.3831 18.5363 17.6736 18.1647C17.954 17.8085 18.0611 17.3454 17.9591 16.9026Z"
          fill="#828282"
        />
      </g>
      <defs>
        <clipPath id="clip0_30_9">
          <rect
            width="12"
            height="14.25"
            fill="white"
            transform="translate(5.99988 4.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Me;
